// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Home Button

sideMenuButton = {};

sideMenuButton.create = function () {
  var button = new PIXI.Container();

  this._sideMenuOpen = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canEnable = function () {
    return (
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._sideMenuOpen &&
      !gdk.serverParser._inReplayMode &&
      !gdk.serverParser._inRewatchMode
    );
  };

  button.canShow = function () {
    return true;
  };

  button.onPressedCallback = function () {
    messageBus.postImmediate("game:sideMenuOpen", { reason: "Side Menu Open" });
    if (button.soundName !== "") button.playSound();
  };

  button.sideMenuOpenMsg = function () {
    this._sideMenuOpen = true;
    resourceManager.get(
      "uiContainer:buttonContainer:sideMenu:glow"
    ).visible = true;
  };

  button.sideMenuClosedMsg = function () {
    this._sideMenuOpen = false;
    resourceManager.get(
      "uiContainer:buttonContainer:sideMenu:glow"
    ).visible = false;
  };

  button.layoutComplete = function () {
    resourceManager.get(
      "uiContainer:buttonContainer:sideMenu:glow"
    ).visible = false;
  };

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.layoutComplete.bind(button)
  );

  messageBus.subscribe(
    "game:sideMenuOpen",
    button.sideMenuOpenMsg.bind(button)
  );
  messageBus.subscribe(
    "game:sideMenuClosed",
    button.sideMenuClosedMsg.bind(button)
  );

  return button;
};

sideMenuButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};

sideMenuButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "sideMenuButton",
  sideMenuButton.create,
  sideMenuButton.initialise,
  sideMenuButton.getFilesRequired
);
